import React from 'react';
import { XCircle, ArrowDown } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = [{
    text: 'Querés generar ',
    highlight: 'plata extra desde casa',
    rest: ' pero no sabés qué vender ni por dónde empezar.'
  }, {
    text: 'Intentaste vender postre/comida antes pero ',
    highlight: 'no te salió',
    rest: ' porque no tenías un sistema claro de recetas, precios y clientes.'
  }, {
    text: 'Pasás horas viendo videos de "cómo emprender" pero ',
    highlight: 'nunca pasás a la acción',
    rest: ' porque todo te parece muy complicado.'
  }, {
    text: 'Querés cobrar por lo que hacés pero ',
    highlight: 'te da vergüenza poner precio',
    rest: ' o sentís que "nadie te va a comprar a vos".'
  }, {
    text: '',
    highlight: 'No podés pagar $150.000 en un curso',
    rest: ' de gastronomía ni $80.000 en una consultoría de negocios para aprender lo que está acá adentro.'
  }];
  const solutions = [{
    emoji: '📦',
    text: 'Vas a pasar de tener ingredientes en el estante a tener frascos listos para vender este fin de semana.'
  }, {
    emoji: '💰',
    text: 'Vas a entender EXACTAMENTE cuánto cobrar por cada frasco para ganar bien sin regalar tu trabajo.'
  }, {
    emoji: '📲',
    text: 'Vas a tener los mensajes de WhatsApp para ofrecer tus productos sin improvisar y sin pasar vergüenza.'
  }, {
    emoji: '⚡',
    text: 'Vas a tener un sistema de consulta para toda la vida. Cada vez que quieras lanzar una receta nueva, abrís la Biblia y ya sabés qué hacer.'
  }, {
    emoji: '🚀',
    text: 'Vas a pasar de "quiero emprender algún día" a tener tu primer cliente real en menos de 48 horas.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <div className="mb-10 md:mb-20" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 md:mb-12 text-gray-900" data-id="element-156">
            Este Recurso Es Para <span className="text-spice-600" data-id="element-157">VOS</span> Si…
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-158">
            {painPoints.map((point, index) => <div key={index} className={`bg-white border-2 border-red-100 rounded-2xl p-4 md:p-6 shadow-sm relative overflow-hidden ${index === painPoints.length - 1 ? 'md:col-span-2 md:max-w-lg md:mx-auto' : ''}`} data-id="element-159">
                <div className="absolute top-0 left-0 w-1.5 h-full bg-gradient-to-b from-red-800 to-red-600" data-id="element-160"></div>
                <div className="flex items-start pl-3" data-id="element-161">
                  <XCircle className="w-6 h-6 text-red-700 mr-4 flex-shrink-0 mt-0.5" data-id="element-162" />
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-163">
                    {point.text}
                    <span className="font-bold text-red-800" data-id="element-164">
                      {point.highlight}
                    </span>
                    {point.rest}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="flex justify-center mb-8 md:mb-16" data-id="element-165">
          <div className="bg-spice-100 rounded-full p-2 md:p-3 border border-spice-200" data-id="element-166">
            <ArrowDown className="w-6 h-6 md:w-8 md:h-8 text-spice-500" data-id="element-167" />
          </div>
        </div>

        <div data-id="element-168">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 md:mb-12 text-gray-900" data-id="element-169">
            ¿Qué Lográs Con Este Recurso?
          </h2>
          <div className="space-y-3 md:space-y-5" data-id="element-170">
            {solutions.map((solution, index) => <div key={index} className="flex items-start bg-spice-50 border border-spice-200 p-4 md:p-5 rounded-2xl" data-id="element-171">
                <span className="text-2xl md:text-3xl mr-3 md:mr-5 flex-shrink-0" data-id="element-172">
                  {solution.emoji}
                </span>
                <p className="text-gray-800 text-base md:text-lg font-medium" data-id="element-173">
                  {solution.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}